module.exports = __webpack_public_path__ + "assets/img/Overall Landscape Deck.cf12508f.jpg";